/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).global = window;
